// 2020-06-27export { TropaEncierreComponent } from './tropa-encierre.component';